module.exports = __webpack_public_path__ + "static/media/share-alt-solid.2d8e3b4f.svg";